var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "col-md-3" }, [
        _c("label", { attrs: { for: "" } }, [_vm._v("Status:")]),
        _vm._v(" "),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.status,
                expression: "status"
              }
            ],
            staticClass: "form-control",
            attrs: { name: "", id: "" },
            on: {
              change: [
                function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.status = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
                _vm.changeData
              ]
            }
          },
          [
            _c("option", { attrs: { value: "" } }, [_vm._v("TODOS")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "ABERTO" } }, [_vm._v("Aberto")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "ENVIADO" } }, [_vm._v("Enviado")]),
            _vm._v(" "),
            _c("option", { attrs: { value: "DELETADO" } }, [_vm._v("Deletado")])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [_vm._v(" Revendedoras: ")]),
          _vm._v(" "),
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.revendedora,
                  expression: "revendedora"
                }
              ],
              staticClass: "form-control",
              attrs: { name: "", id: "" },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.revendedora = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.changeData
                ]
              }
            },
            [
              _c("option", { attrs: { value: "0" } }, [_vm._v("Todas")]),
              _vm._v(" "),
              _vm._l(_vm.revendedoras, function(revend) {
                return _c(
                  "option",
                  { key: revend.id, domProps: { value: revend.id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(revend.nome) +
                        "\n                    "
                    ),
                    revend.pdv
                      ? _c("span", [
                          _vm._v(" ( " + _vm._s(revend.pdv.nome) + " )")
                        ])
                      : _vm._e()
                  ]
                )
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "" } }, [_vm._v("De:")]),
            _vm._v(" "),
            _c("date-picker", {
              attrs: { disabled: _vm.status === "ABERTO" },
              on: { "dp-change": _vm.changeData },
              model: {
                value: _vm.fromDate,
                callback: function($$v) {
                  _vm.fromDate = $$v
                },
                expression: "fromDate"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-3" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("label", { attrs: { for: "" } }, [_vm._v("Até:")]),
            _vm._v(" "),
            _c("date-picker", {
              attrs: { disabled: _vm.status === "ABERTO" },
              on: { "dp-change": _vm.changeData },
              model: {
                value: _vm.toDate,
                callback: function($$v) {
                  _vm.toDate = $$v
                },
                expression: "toDate"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-12" }, [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _vm.status === "ABERTO" && !_vm.checkBonificado()
              ? _c(
                  "b-button",
                  {
                    staticClass: "ml-1 float-right",
                    attrs: { variant: "danger", size: "sm" },
                    on: { click: _vm.deletarPedido }
                  },
                  [
                    _c("i", { staticClass: "fas fa-trash" }),
                    _vm._v(" Deletar Pedidos\n            ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.status === "ABERTO" && _vm.profile.pdv == null
              ? _c(
                  "b-button",
                  {
                    staticClass: "ml-1 float-right",
                    attrs: { variant: "success", size: "sm" },
                    on: { click: _vm.abrirModalDados }
                  },
                  [
                    _c("i", { staticClass: "fas fa-paper-plane" }),
                    _vm._v(" Enviar Pedidos\n            ")
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.status === "DELETADO" && _vm.profile.pdv == null
              ? _c(
                  "b-button",
                  {
                    staticClass: "ml-1 float-right",
                    attrs: { variant: "danger", size: "sm" },
                    on: { click: _vm.recuperarDeletados }
                  },
                  [
                    _c("i", { staticClass: "fas fa-undo" }),
                    _vm._v(" Recuperar Pedidos\n            ")
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "col-md-12 mt-1" },
        [
          _vm.valor_acao_comercial > 0
            ? _c(
                "div",
                {
                  staticClass:
                    "card-acao-comercial mb-3 position-relative overflow-hidden"
                },
                [
                  _vm.acao_comercial_enviada
                    ? _c("div", { staticClass: "overlay-brindes" }, [
                        _c("div", { staticClass: "text-center" }, [
                          _c("i", {
                            staticClass:
                              "fas fa-check-circle text-success mb-2",
                            staticStyle: { "font-size": "2rem" }
                          }),
                          _vm._v(" "),
                          _c(
                            "h4",
                            {
                              staticClass: "text-success font-weight-bold mb-0"
                            },
                            [
                              _vm._v(
                                "Brindes já inseridos no Lote " +
                                  _vm._s(_vm.acao_comercial_enviada)
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "cabecalho-acao" }, [
                    _c("h5", { staticClass: "titulo" }, [
                      _vm._v("Ação Comercial em Andamento")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "descricao" }, [
                    _vm._v("\n                Alcance um crescimento de "),
                    _c("strong", [_vm._v("10%")]),
                    _vm._v(
                      " sobre o seu último mês e antecipe seus pedidos para antes do dia "
                    ),
                    _c("strong", [_vm._v("15")]),
                    _vm._v(
                      "! Cumprindo esses requisitos, você ganha o equivalente a "
                    ),
                    _c("strong", [_vm._v("6%")]),
                    _vm._v(
                      " do valor de envio do mês em brindes.\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-warning mb-2" }, [
                    _c("i", {
                      staticClass: "fas fa-info-circle mb-2",
                      staticStyle: { "font-size": "1rem" }
                    }),
                    _vm._v(
                      " Produtos Encarte (sem desconto) não contabilizam para o programa de incentivo"
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "area-progresso" }, [
                    _c("div", { staticClass: "info-progresso" }, [
                      _c("span", [
                        _vm._v("\n                        Progresso: "),
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.totalItensIncentivo +
                                _vm.acao_comercial_enviado_itens
                            )
                          )
                        ]),
                        _vm._v(" \n                        de "),
                        _c("strong", [_vm._v(_vm._s(_vm.meta_esperada))]),
                        _vm._v(" "),
                        _c("small", { staticClass: "text-muted ml-1" }, [
                          _vm._v(
                            "(sendo " +
                              _vm._s(_vm.valor_acao_comercial) +
                              " + 10%)"
                          )
                        ]),
                        _vm._v(" itens \n                    ")
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "porcentagem" }, [
                        _vm._v(_vm._s(_vm.porcentagem_concluida) + "%")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "barra-fundo" }, [
                      _c("div", {
                        staticClass: "barra-preenchimento",
                        style: { width: _vm.porcentagem_concluida + "%" }
                      })
                    ])
                  ])
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "ABERTO" || _vm.status === "DELETADO"
            ? _c("b-card-header", [
                _c("p", { staticClass: "text-left" }, [
                  _c("strong", { staticClass: "text-primary" }, [
                    _vm._v("Pedidos Selecionados: ")
                  ]),
                  _vm._v(
                    _vm._s(
                      _vm.checkBonificado()
                        ? _vm.enviar.length - 1
                        : _vm.enviar.length
                    ) + "\n                "
                  ),
                  _c("strong", { staticClass: "text-primary" }, [
                    _vm._v(" | ")
                  ]),
                  _vm._v(" "),
                  _c("strong", { staticClass: "text-primary" }, [
                    _vm._v("Itens Selecionados: ")
                  ]),
                  _vm._v(_vm._s(_vm.totalItensSelecionados) + "\n            ")
                ]),
                _vm._v(" "),
                _vm.errors.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.errors, function(erro, e) {
                        return _c("div", { key: e, staticClass: "row" }, [
                          _c("div", { staticClass: "alert alert-danger" }, [
                            _vm._v(_vm._s(_vm.errors))
                          ])
                        ])
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-card-body",
            [
              _c("b-table", {
                attrs: {
                  "per-page": _vm.perPage,
                  busy: _vm.isLoading,
                  hover: "",
                  striped: "",
                  responsive: "",
                  fields: _vm.colunas,
                  items: _vm.dataTable,
                  "current-page": _vm.currentPage
                },
                scopedSlots: _vm._u([
                  {
                    key: "table-busy",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-danger my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Carregando...")])
                          ],
                          1
                        )
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "head(id)",
                    fn: function() {
                      return [
                        _vm.status === "ABERTO" || _vm.status === "DELETADO"
                          ? _c("b-form-checkbox", {
                              attrs: {
                                indeterminate: _vm.indeterminate,
                                value: true
                              },
                              on: { change: _vm.changeMarcarTodos },
                              model: {
                                value: _vm.todosMarcado,
                                callback: function($$v) {
                                  _vm.todosMarcado = $$v
                                },
                                expression: "todosMarcado"
                              }
                            })
                          : _vm._e()
                      ]
                    },
                    proxy: true
                  },
                  {
                    key: "cell(id)",
                    fn: function(row) {
                      return [
                        _vm.status === "ABERTO" || _vm.status === "DELETADO"
                          ? _c("b-form-checkbox", {
                              key: row.value,
                              attrs: { stacked: "", value: row.value },
                              on: {
                                change: function($event) {
                                  return _vm.changeMarcar(row.item)
                                }
                              },
                              model: {
                                value: _vm.enviar,
                                callback: function($$v) {
                                  _vm.enviar = $$v
                                },
                                expression: "enviar"
                              }
                            })
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "cell(lote)",
                    fn: function(row) {
                      return [
                        row.value && !_vm.profile.pdv
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: "/lotes/" + row.value,
                                  target: "_blank"
                                }
                              },
                              [_vm._v(_vm._s(row.value))]
                            )
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "cell(opcoes)",
                    fn: function(row) {
                      return [
                        _vm.status === "ABERTO"
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mt-1",
                                attrs: {
                                  variant: "primary",
                                  title: "Visualizar Pedido"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showPedido(row.item.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-eye" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "downloadexcel",
                          {
                            staticClass: "btn btn-success mt-1",
                            attrs: {
                              name: _vm.filename,
                              worksheet: "" + row.item.nome,
                              title: "Exportar Pedido",
                              fetch: function() {
                                return _vm.startDownload(row.item.id)
                              },
                              "before-generate": _vm.exportExcel,
                              "before-finish": _vm.finishExcel
                            }
                          },
                          [_c("i", { staticClass: "far fa-file-excel" })]
                        ),
                        _vm._v(" "),
                        _vm.status === "ABERTO"
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mt-1",
                                attrs: {
                                  variant: "warning",
                                  title: "Editar Pedido"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.editPedido(row.item)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-edit" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.status === "ABERTO" && !row.item.bonificacao
                          ? _c(
                              "b-button",
                              {
                                staticClass: "mt-1",
                                attrs: {
                                  variant: "danger",
                                  title: "Deletar Pedido"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deletarPedidoLinha(row.item.id)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            )
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _vm.pedidos.length > 19
                ? _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage,
                      align: "center"
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.profile.email !== undefined
        ? _c(
            "b-modal",
            {
              attrs: {
                size: "lg",
                title: "Confirmação de Dados",
                "hide-footer": ""
              },
              model: {
                value: _vm.cadPopModal,
                callback: function($$v) {
                  _vm.cadPopModal = $$v
                },
                expression: "cadPopModal"
              }
            },
            [
              _c(
                "b-card",
                [
                  _c("div", { staticClass: "row mb-3" }, [
                    _c("label", [
                      _vm._v(
                        "Atualize seus dados pessoais. Insira seu email e telefone para contato."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "list-group-item" }, [
                    _c("label", [_vm._v("E-mail para contato:")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-7" },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                id: "input-group-1",
                                label: "Confirme seu email:",
                                "label-for": "input-1",
                                description: "Endereço de e-mail válido"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-1",
                                  type: "email",
                                  placeholder: "email@email.com"
                                },
                                model: {
                                  value: _vm.profile.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.profile, "email", $$v)
                                  },
                                  expression: "profile.email"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.profile.contatos && _vm.profile.contatos[0]
                    ? _c("div", { staticClass: "list-group-item" }, [
                        _c("label", [_vm._v("Telefone atual:")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-2" },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: ["(##)"],
                                    expression: "['(##)']"
                                  }
                                ],
                                attrs: {
                                  id: "input-1",
                                  type: "phone",
                                  placeholder: "DDD",
                                  required: ""
                                },
                                model: {
                                  value: _vm.profile.contatos[0].telefone.ddd,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.profile.contatos[0].telefone,
                                      "ddd",
                                      $$v
                                    )
                                  },
                                  expression: "profile.contatos[0].telefone.ddd"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-5" },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: [
                                      "# ####-####",
                                      "#####-####",
                                      "####-####"
                                    ],
                                    expression:
                                      "['# ####-####', '#####-####', '####-####']"
                                  }
                                ],
                                attrs: {
                                  id: "input-1",
                                  type: "phone",
                                  placeholder: "Somente o numero sem o ddd"
                                },
                                model: {
                                  value:
                                    _vm.profile.contatos[0].telefone.numero,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.profile.contatos[0].telefone,
                                      "numero",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "profile.contatos[0].telefone.numero"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.profile.contatos && _vm.profile.contatos[1]
                    ? _c("div", { staticClass: "list-group-item" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-2 mt-2" },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: ["(##)"],
                                    expression: "['(##)']"
                                  }
                                ],
                                attrs: {
                                  id: "input-1",
                                  type: "phone",
                                  placeholder: "DDD",
                                  required: ""
                                },
                                model: {
                                  value: _vm.profile.contatos[1].telefone.ddd,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.profile.contatos[1].telefone,
                                      "ddd",
                                      $$v
                                    )
                                  },
                                  expression: "profile.contatos[1].telefone.ddd"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-5 mt-2" },
                            [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "mask",
                                    rawName: "v-mask",
                                    value: [
                                      "# ####-####",
                                      "#####-####",
                                      "####-####"
                                    ],
                                    expression:
                                      "['# ####-####', '#####-####', '####-####']"
                                  }
                                ],
                                attrs: {
                                  id: "input-1",
                                  type: "phone",
                                  placeholder: "Somente o numero sem o ddd"
                                },
                                model: {
                                  value:
                                    _vm.profile.contatos[1].telefone.numero,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.profile.contatos[1].telefone,
                                      "numero",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "profile.contatos[1].telefone.numero"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c("label", [
                      _vm._v(
                        "Os campos de e-mail e telefone são opcionais. Caso os dados estejam corretos, pode prosseguir normalmente."
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.onSubmitCad.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1 float-right",
                          attrs: { type: "submit", variant: "primary" },
                          on: { click: _vm.confirmarEnvioPedido }
                        },
                        [
                          _c("i", { staticClass: "fas fa-save" }),
                          _vm._v(" Salvar")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-1 mb-15 float-right",
                          attrs: { variant: "secondary" },
                          on: {
                            click: function($event) {
                              _vm.cadPopModal = false
                            }
                          }
                        },
                        [_vm._v(" Cancelar ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            "no-close-on-backdrop": "",
            "hide-header": "",
            "no-close-on-esc": "",
            "no-enforce-focus": "",
            "no-stacking": "",
            size: "lg"
          },
          model: {
            value: _vm.modalEnvio,
            callback: function($$v) {
              _vm.modalEnvio = $$v
            },
            expression: "modalEnvio"
          }
        },
        [
          _c("b-row", [
            _c("h2", [_vm._v("Enviando os pedidos, NÃO atualize a página!")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _c("img", { attrs: { src: "/images/send-order.gif", alt: "send" } })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "chose-modal",
            size: "xl",
            "header-bg-variant": "light",
            title: "Ação Comercial - Escolha seus brindes",
            scrollable: "",
            centered: ""
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var close = ref.close
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function($event) {
                          return close()
                        }
                      }
                    },
                    [_vm._v("\n                Cancelar\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "px-4",
                      attrs: { variant: "success" },
                      on: { click: _vm.confirmarCarrinho }
                    },
                    [
                      _vm._v(
                        "\n                Confirmar Seleção\n            "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _c(
            "b-container",
            { staticClass: "px-0", attrs: { fluid: "" } },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { staticClass: "pr-md-4", attrs: { md: "8" } },
                    [
                      _c("h5", { staticClass: "mb-4 border-bottom pb-2" }, [
                        _vm._v("Produtos Disponíveis")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        _vm._l(_vm.produtos, function(produto) {
                          return _c(
                            "b-col",
                            {
                              key: produto.id,
                              staticClass: "mb-4",
                              attrs: { md: "4", sm: "6" }
                            },
                            [
                              _c(
                                "b-card",
                                {
                                  staticClass:
                                    "h-100 text-center product-card border-0 shadow-sm",
                                  attrs: { "no-body": "" }
                                },
                                [
                                  _c("b-card-img", {
                                    staticClass: "product-img",
                                    attrs: {
                                      src: produto.imagem
                                        ? produto.imagem
                                        : "https://placehold.co/300x200?text=Sem+Imagem",
                                      top: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-card-body",
                                    { staticClass: "d-flex flex-column p-3" },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass: "text-truncate mb-1",
                                          attrs: {
                                            title:
                                              "(" +
                                              produto.codigo +
                                              ") " +
                                              produto.nome
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              "(" +
                                                produto.codigo +
                                                ") " +
                                                produto.nome
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "text-primary font-weight-bold mb-3"
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        R$ " +
                                              _vm._s(
                                                Number(
                                                  produto.pivot.preco
                                                ).toFixed(2)
                                              ) +
                                              "\n                                    "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-auto" },
                                        [
                                          _c(
                                            "b-input-group",
                                            {
                                              staticClass: "mb-2 w-75 mx-auto",
                                              attrs: { size: "sm" }
                                            },
                                            [
                                              _c(
                                                "b-input-group-prepend",
                                                { attrs: { "is-text": "" } },
                                                [_vm._v("Qtd")]
                                              ),
                                              _vm._v(" "),
                                              _c("b-form-input", {
                                                staticClass: "text-center",
                                                attrs: {
                                                  type: "number",
                                                  min: "1"
                                                },
                                                model: {
                                                  value: produto.quantidadeTemp,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      produto,
                                                      "quantidadeTemp",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "produto.quantidadeTemp"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-button",
                                            {
                                              staticClass:
                                                "w-100 font-weight-bold",
                                              attrs: {
                                                variant: "primary",
                                                size: "sm",
                                                disabled:
                                                  _vm.totalCarrinho +
                                                    Number(
                                                      produto.pivot.preco
                                                    ) *
                                                      (produto.quantidadeTemp ||
                                                        1) >
                                                  _vm.limiteValor
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.adicionarAoCarrinho(
                                                    produto
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                            Adicionar\n                                        "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("b-col", { attrs: { md: "4" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "bg-light rounded p-3 d-flex flex-column border"
                      },
                      [
                        _c("h5", { staticClass: "mb-3 border-bottom pb-2" }, [
                          _vm._v("Seu Carrinho")
                        ]),
                        _vm._v(" "),
                        _vm.carrinho.length === 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-center text-muted my-auto py-5"
                              },
                              [
                                _c("p", [
                                  _vm._v("Seu carrinho está vazio."),
                                  _c("br")
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "cart-scroll-area flex-grow-1" },
                              [
                                _c(
                                  "b-list-group",
                                  { attrs: { flush: "" } },
                                  _vm._l(_vm.carrinho, function(item) {
                                    return _c(
                                      "b-list-group-item",
                                      {
                                        key: item.id,
                                        staticClass:
                                          "bg-transparent px-0 py-2 border-bottom"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-start mb-1"
                                          },
                                          [
                                            _c(
                                              "strong",
                                              {
                                                staticClass:
                                                  "text-truncate mr-2"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    "(" +
                                                      item.codigo +
                                                      ") " +
                                                      item.nome
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-button",
                                              {
                                                staticClass:
                                                  "text-danger p-0 text-decoration-none",
                                                attrs: {
                                                  variant: "link",
                                                  title: "Remover"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.removerDoCarrinho(
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            🗑️\n                                        "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex justify-content-between align-items-center"
                                          },
                                          [
                                            _c(
                                              "small",
                                              { staticClass: "text-muted" },
                                              [
                                                _vm._v(
                                                  "R$ " +
                                                    _vm._s(
                                                      Number(
                                                        item.pivot.preco
                                                      ).toFixed(2)
                                                    ) +
                                                    " /un"
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("b-form-input", {
                                              staticClass:
                                                "cart-qty-input text-center",
                                              attrs: {
                                                type: "number",
                                                min: "1",
                                                size: "sm"
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.validarQuantidadeCarrinho(
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.quantidade,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "quantidade",
                                                    _vm._n($$v)
                                                  )
                                                },
                                                expression: "item.quantidade"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "mt-4 pt-3 border-top" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between mb-2"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "font-weight-bold text-muted"
                                  },
                                  [_vm._v("Total:")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "h5",
                                  {
                                    staticClass:
                                      "font-weight-bold text-primary mb-0"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    R$ " +
                                        _vm._s(_vm.totalCarrinho.toFixed(2)) +
                                        "\n                                "
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-between mb-1"
                              },
                              [
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v("Limite disponível:")
                                ]),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "font-weight-bold" },
                                  [
                                    _vm._v(
                                      "R$ " + _vm._s(_vm.limiteValor.toFixed(2))
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-progress",
                              {
                                staticClass: "mt-2 shadow-sm",
                                attrs: { height: "8px" }
                              },
                              [
                                _c("b-progress-bar", {
                                  attrs: {
                                    value: _vm.totalCarrinho,
                                    max: _vm.limiteValor,
                                    variant: _vm.progressoVariante
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "mt-1 text-center",
                                staticStyle: { height: "20px" }
                              },
                              [
                                _vm.totalCarrinho >= _vm.limiteValor
                                  ? _c(
                                      "small",
                                      {
                                        staticClass:
                                          "text-danger font-weight-bold fade-in"
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    ⚠️ Limite de valor atingido!\n                                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19332bde", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19332bde","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedidos/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-19332bde","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/pedidos/Main.vue
// module chunks = 2